import { CircularProgress } from "@material-ui/core";
import { SalesforceLogin } from "../Salesforce/SalesforceLogin";
import React, { useEffect } from "react";
import { ApiException, useGroupContext } from "groopit-js";

export const SalesforceEditAuthenticator = () => {
  const { sfConnectionId } = useGroupContext();
  const [canEdit, setCanEdit] = React.useState<boolean>();
  const [showError, setShowError] = React.useState(false);

  const checkEditStatus = (sfConnectionId: string, showErrors: boolean) => {
    // If there are any SF links then we need to check the users
    // authentication status and potentially ask them to sign in.
    setCanEdit(undefined);
    if (sfConnectionId) {
      fetch(`/salesforce/canedit?serviceId=${sfConnectionId}`, {
        method: "GET",
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            return response.text().then((_responseText) => {
              throw new ApiException(
                "An unexpected server error occurred.",
                response.status,
                _responseText,
                response.headers,
                null,
              );
            });
          }
        })
        .then((response) => {
          if (response.success) {
            setCanEdit(response.canEdit);
          } else {
            console.error(response.error);
            setCanEdit(false);
            if (showErrors) {
              setShowError(true);
            }
          }
        })
        .catch((err) => {
          console.error(err);
          setCanEdit(false);
          if (showErrors) {
            setShowError(true);
          }
        });
    }
  };

  useEffect(() => {
    if (sfConnectionId) {
      checkEditStatus(sfConnectionId, false);
    }
  }, [sfConnectionId]);

  if (sfConnectionId) {
    if (canEdit === undefined) {
      return (
        <div>
          <div className="text-center">
            <CircularProgress />
          </div>
          <hr className="small-divider" />
        </div>
      );
    } else if (!canEdit) {
      return (
        <div>
          <div className="text-display-title">Sign In to Salesforce</div>
          <div className="text-display-normal">
            These fields are connected to Salesforce. Please sign in to ensure
            your data is shared with Salesforce.
          </div>
          <SalesforceLogin
            connectionId={sfConnectionId}
            onLogin={() => checkEditStatus(sfConnectionId, true)}
          />
          {showError && (
            <div className="text-danger">
              We are unable to sign you in at this time. If the problem
              persists, please contact your Salesforce administrator.
            </div>
          )}
          <hr className="small-divider" />
        </div>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};
